import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Title from '../../shared/Title';
import FFPaper from '../../shared/FFPaper';
import MultipleDropDownMenu from '../../shared/MultipleDropDownMenu';
import EventsByGroupPieChart from './EventsByGroupPieChart';
import KebabMenu, { defaultMenus } from '../../shared/KebabMenu';
import ChartContainer from '../../shared/ChartContainer';

const handler = (menu: string) => {
     console.log(menu);
}

export default function EventsByGroupCard() {

    return (
        <Grid item={true} xs={4} >
            <FFPaper
                sx={{
                    alignItems: 'stretch',
                    position: 'relative',
                    flexDirection: 'row',
                    height: '100%',
                }}
            >
                <KebabMenu
                    menus={defaultMenus}
                    handler={handler}
                />

                <Grid item={true} xs={12} sx={{ 
                    flexDirection: 'column', position: 'relative', pb: 1, pt: 1, pl: 1, pr: 1 }}>
                    <Stack direction="row" spacing={2} sx={{ mr: 5, pl: 2, pr: 2, width: '100%' }}>
                        <Title subtitle="Last update 1 min ago" notooltip={true}>Events by Group</Title>
                        <MultipleDropDownMenu multipleLabel='Groups' label="Groups" options={['VIP', 'Shoplifters', 'Fraudsters', 'Managers']} />
                    </Stack>
                    <Box sx={{
                        width: '100%',
                        height: '90%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        overflowX: 'auto',
                    }}>
                        <Box sx={{
                            pt: 1,
                            width: 480,
                            height: 320,
                            minWidth: 450,
                        }}>
                            <ChartContainer>
                                <EventsByGroupPieChart />
                            </ChartContainer>
                        </Box>
                    </Box>
                </Grid>

            </FFPaper>
        </Grid>
    )
}


